<template>
  <v-card :color="color" :dark="app.isEnabled">
    <v-card-title>
      <v-icon left>{{app.icon}}</v-icon>
      {{app.name}}
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('settings')">
        <v-icon>settings</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-actions>
      <template v-if="qlikAppExist">
        <v-chip outlined class="mr-1">
          <v-icon left>link</v-icon>
          {{ app.qDoc.qDocName }}
        </v-chip>
        <v-chip outlined v-if="qlikAppExist">
          <v-icon left>update</v-icon>
          {{ lastReload }}
        </v-chip>
      </template>
      <template v-else>
        <v-chip outlined>
          <v-icon left>warning</v-icon>
          {{$t('QlikApp.Message.notFoundWarning')}}
        </v-chip>
      </template>
      <v-spacer></v-spacer>
      <v-btn icon @click="expand = !expand">
        <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-expand-transition>
      <div v-show="expand">
        <v-divider></v-divider>
        <v-card-text>
          {{app.description}}
        </v-card-text>
        <v-card-actions>
          <v-btn @click="$emit('disconnect')" outlined block>
            <v-icon left>link_off</v-icon>
            {{$t('Global.Action.disconnect')}}
          </v-btn>
        </v-card-actions>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import { DateMixin } from '@/mixins/index'

export default {
  name: 'AppCard',
  mixins: [ DateMixin ],
  props: {
    app: { type: Object, required: true }
  },
  data: () => ({
    expand: false
  }),
  computed: {
    qlikAppExist () {
      return !!this.app.qDoc
    },
    color () {
      if (!this.qlikAppExist) return 'error'
      if (!this.app.isEnabled) return 'grey lighten-3'
      return this.app.color || 'primary'
    },
    connectedUser () {
      return this.app.qDoc.qConnectedUser || 0
    },
    lastReload () {
      return this.$_date_formatDistance(this.app.qDoc.qLastReloadTime)
    }
  }
}
</script>